<template>
  <div class="fabricator">
    <div class="fabricator__iframe" :class="isCondensed ? 'is-condensed' : ''">
      <iframe
        id="fabricator"
        src="https://d1gmu4ezl274zg.cloudfront.net/vispring_fabricator/"
        ref="model"
        style="width: 100%; height: 100%"
      ></iframe>
    </div>
    <div class="fabricator__navbar">
      <div class="fabricator__icon icon">
        <rotate-svg-s v-if="window.width < 768" />
        <rotate-svg v-else />
      </div>
      <div class="fabricator__button" v-if="window.width < 768">
        <button
          type="button"
          role="button"
          :aria-label="
            isCondensed
              ? options.fabricator.expand
              : options.fabricator.condense
          "
          :class="classObject()"
          @click="toggleExpand"
        >
          <span class="name">{{
            isCondensed
              ? options.fabricator.expand
              : options.fabricator.condense
          }}</span>
          <span class="icon"><expand-svg /></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from '../../mixin';
import RotateSvgS from '../../../../../assets/img/icons/rotates.svg';
import RotateSvg from '../../../../../assets/img/icons/rotate.svg';
import ExpandSvg from '../../../../../assets/img/icons/expand.svg';

export default {
  name: 'fabricator',
  mixins: [mixin],
  components: {
    RotateSvgS,
    RotateSvg,
    ExpandSvg,
  },
  data() {
    return {
      isCondensed: false,
      results: [],
      actionResults: [],
    };
  },
  created() {
    // if (window) {
    //   window.addEventListener('resize', this.handleResize);
    //   this.handleResize();
    // }
  },
  destroyed() {
    // if (window) {
    //   window.removeEventListener('resize', this.handleResize);
    // }
  },
  computed: {
    options() {
      return this.$store.state.siteData;
    },
    actionName() {
      return this.$store.getters.actionName;
    },
    product() {
      return this.$store.getters.product;
    }
  },
  mounted() {
    this.$nextTick(() => this.loadModel());
  },
  methods: {
    classObject() {
      return {
        'button-expand': true,
        'is-active': this.isCondensed,
      };
    },
    // handleResize() {
    //   if (this.window.width >= 1200) {
    //     this.loadModel(';zoom:-0.3');
    //   } else {
    //     this.loadModel('');
    //   }
    // },
    loadModel() {
      this.results = Object.values(this.actionName);
      // this.results.forEach((result, inx) => {
      //   this.$refs.model.addEventListener('load', () => {
      //     if (result !== '') {
      //       setTimeout(() => {
      //         this.sendActionToFabricator(result)
      //       }, 1000 * (inx + 1))
      //     }
      //   })
      // })
      if (this.product && this.product.length) {
        const newProduct = 'loadProduct=' + this.product.join(';') + ';zoom:-0.3' + '.glb';
        if (this.$refs.model) {
          this.$refs.model.addEventListener('load', () => {
            this.sendActionToFabricator(newProduct)
          })
        }
      } else {
        const newProduct = 'loadProduct=hb:hw:9023;divan:mtl:2026;mattress:hw:9022;hb:mtl:2026;divan:hw:7668;legs:hw:8948;zoom:-0.3.glb;';
        if (this.$refs.model) {
          this.$refs.model.addEventListener('load', () => {
            this.sendActionToFabricator(newProduct)
          })
        }
      }
    },
    sendActionToFabricator(actionName) {
      const fabricator = this.$refs.model.contentWindow;
      fabricator.postMessage(actionName, '*');
    },
    toggleExpand() {
      this.isCondensed = !this.isCondensed;
      this.$emit('handleExpand', this.isCondensed);
    },
  },
  watch: {
    '$store.state.sentActionName'(value, oldValue) {
      this.sendActionToFabricator(value);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.fabricator {
  //position: relative;
  //padding: 74px 0 53px;
  width: 100%;
  height: 100%;
  max-height: calc(42.1333vw + 88px);
  display: flex;
  justify-content: center;
  align-items: center;
  //overflow: hidden;

  //@include up-tablet {
  //  padding: 64px 0 63px;
  //  max-height: 30.208vw;
  //}

  @include up-laptop {
    padding: 0;
    max-height: 100vh;
  }

  .touch & {
    @media (min-width: 1024px) and (orientation: landscape) {
      padding: 0;
      max-height: 100vh;
    }

    @include up-laptop {
      padding: 0;
      max-height: 100vh;
    }
  }

  &__iframe {
    //width: 76vw;
    //width: 100%;
    width: auto;
    height: 100%;
    //overflow: hidden;
    transition: opacity .25s;

    //@include up-tablet {
    //  width: 54.427vw;
    //  height: calc(42.1333vw + 88px);
    //}

    @include up-laptop {
      width: 100%;
      //height: 100%;
      //width: 57.847vw;
      //height: 32.08vw;
    }

    .touch & {
      @media (min-width: 1024px) and (orientation: landscape) {
        width: 100%;
      }

      @include up-laptop {
        width: 100%;
      }
    }

    &.is-condensed {
      position: absolute;
      opacity: 0;
      pointer-events: none;
      transition: none;
    }
  }

  &__icon,
  &__button {
    position: absolute;
  }

  &__icon {
    bottom: 16.24px;
    left: 16.28px;
    display: flex;
    align-items: flex-end;

    @include up-tablet {
      bottom: 26px;
      left: 20px;
    }

    //svg,
    //g,
    //path {
    //  width: 100%;
    //  height: auto;
    //}
  }

  &__button {
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);

    .button-expand {
      display: flex;
      align-items: center;

      &.is-active {
        .icon {
          margin-bottom: 3px;
          transform: rotate(180deg);
        }
      }

      .name {
        font-family: $f-neutraBold;
        font-size: 12px;
        line-height: 12px;
        letter-spacing: 1.5px;
        text-transform: uppercase;
      }

      .icon {
        margin-bottom: 2px;
        margin-left: 6.59px;
        display: flex;
        align-items: center;
        transform: rotate(0);
        @include anim(transform);
      }
    }
  }
}
</style>
